module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/portfolio-single-4-a396059caadfadec832653803fa1345f.jpg";